import { GroupedFeatures, ObjectFeature } from '../../types/ObjectTypes';

export const getCategories = (features: Array<ObjectFeature>): string[] => {
  const categories = features.map(feature => {
    return feature.Category;
  });
  return categories.filter((category, pos, arr) => {
    return arr.indexOf(category) === pos;
  });
};

export const findFeaturesByCategory = (
  category: string,
  features: Array<ObjectFeature>,
): ObjectFeature[] => {
  return features.filter(feature => {
    return feature.Category === category;
  });
};

export const getGroupedFeaturesByCategory = (features: Array<ObjectFeature>): GroupedFeatures[] => {
  const categories = getCategories(features);

  return categories.map(category => {
    return {
      category,
      features: findFeaturesByCategory(category, features),
    };
  });
};